import { CalculationTestErrorFile } from "Hub/pages/TaskDetails/types";

import {
  InputDataFile,
  MissingDataCheckEntity,
} from "API/Endpoints/Tasks/payloads";

export type PristineInputDataFiles =
  | { id: string; inputDataFile: InputDataFile | null }[]
  | undefined;

export const enum Tab {
  MISSING_DATA = "missingData",
  MISSING_ENTITIES = "missingEntities",
}

export type SubmitTaskFile = {
  name: string;
  file_id: string;
  activity_id: string;
  methodology_id: string;
  fileBlob?: File;
};

export type CalculationTestError = {
  errorType: string;
  rowNumber: number;
  message: string;
};

export type FilesUploadData = {
  id: string;
  files: SubmitTaskFile[];
  errors?: CalculationTestError[];
}[];

export type CalculationTestData = {
  activityMethodologyId: string;
  emissionFileId: string;
  errors: CalculationTestErrorFile | null;
}[];

export interface ErrorProps {
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  data: Record<string, string[]> | unknown;
  status: number | string;
}

export enum TabVisibility {
  VISIBLE = "visible",
  HIDDEN = "hidden",
}

export type MissingEntity = Omit<MissingDataCheckEntity, "id"> & {
  entityId: string;
  menuId: string;
};

export enum ReloadTrigger {
  FULL = "FULL",
  MISSING_DATA = "MISSING_DATA",
  MISSING_ENTITIES = "MISSING_ENTITIES",
  CLEANING = "CLEANING",
  CALCULATION_TEST = "CALCULATION_TEST",
}
